import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { get, sample } from 'lodash';
import { buildThumbnailUrl, SanitizeHtml } from '@bd/bdcore-utilities';
import { css } from '@bd/bdui-styles/emotion';
import { colors } from '../styles';

const styles = css`
  padding: 0 0 0 0;
  margin: 2px 0 0 0;
  @media(min-width: 992px) {
    padding: 0 0 0 0;
    margin: 2px 0 0 0;
  }
  .TestimonialBannerSection_wrapper {
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    z-index: 1;
    width: 100%;
    @media(min-width: 992px) {
    }
  }
  .TestimonialBannerSection_overlay {
    position: absolute;
    z-index: 2;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(214, 155, 41, 0.92);
  }
  .TestimonialBannerSection_contentWrapper {
    position: relative;
    z-index: 3;
    width: 100%;
    padding: 80px 20px 80px 20px;
    @media(min-width: 992px) {
      padding: 130px 80px 130px 80px;
    }
    .TestimonialBannerSection_content {
      width: 100%;
      padding: 65px 0 0 0;
      background-size: 53px 45px;
      background-image: url(/images/icons/icon-quote.svg);
      background-position: center top;
      background-repeat: no-repeat;
      @media(min-width: 992px) {
        padding: 0 0 10px 140px;
        background-size: 83px 64px;
        background-position: left top;
      }
      .TestimonialBannerSection_testimonial {
        font-size: 17px;
        line-height: 30px;
        display: block;
        color: ${colors.white};
        font-weight: 700;
        @media(min-width: 992px) {
          font-size: 21px;
          color: ${colors.white};
          line-height: 40px;
          padding: 0 0 20px 0;
          text-align: left;
        }
      }
      .TestimonialBannerSection_attribution {
        font-size: 14px;
        letter-spacing: 2px;
        display: block;
        text-align: center;
        width: 100%;
        color: ${colors.white};
        @media(min-width: 992px) {
          font-size: 14px;
          text-transform: uppercase;
          letter-spacing: 3px;
          font-weight: 300;
          line-height: 20px;
          padding: 0 0 0 0;
          text-align: right;
          color: ${colors.white};
        }
        span {
          font-weight: 500;
          @media(min-width: 992px) {
            font-weight: 500;
          }
        }
      }
    }
  }
`;

function TestimonialBanner({ widget, className }) {
  const testimonialSingle = sample(get(widget, 'testimonials'));
  const testimonialImage = sample(get(widget, 'images'));
  return (
    <div className={`${className} ${styles}`}>
      <div className="TestimonialBannerSection_wrapper" style={{ backgroundImage: `url(${buildThumbnailUrl(get(testimonialImage, 'contentUrl'), { width: 1500, height: 1500 })})` }} >
        <div className="TestimonialBannerSection_contentWrapper">
          <div className="TestimonialBannerSection_content">
            <div className="TestimonialBannerSection_testimonial" dangerouslySetInnerHTML={SanitizeHtml(get(testimonialSingle, 'testimonial'))} />
            <div className="TestimonialBannerSection_attribution" dangerouslySetInnerHTML={SanitizeHtml(get(testimonialSingle, 'name'))} />
          </div>
        </div>
        <div className="TestimonialBannerSection_overlay" />
      </div>
    </div>
  );
}

TestimonialBanner.propTypes = {
  widget: PropTypes.object.isRequired,
  className: PropTypes.string,
};

TestimonialBanner.defaultProps = {
  className: '',
};

export default withData(
  {
    widget: 'testimonials_list',
  },
)(TestimonialBanner);



// WEBPACK FOOTER //
// ./src/components/TestimonialBanner.js